var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7515 24C15.7515 25.7949 14.2964 27.25 12.5015 27.25C10.7065 27.25 9.25146 25.7949 9.25146 24C9.25146 22.2051 10.7065 20.75 12.5015 20.75C14.2964 20.75 15.7515 22.2051 15.7515 24Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2515 24C27.2515 25.7949 25.7964 27.25 24.0015 27.25C22.2065 27.25 20.7515 25.7949 20.7515 24C20.7515 22.2051 22.2065 20.75 24.0015 20.75C25.7964 20.75 27.2515 22.2051 27.2515 24Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5015 27.25C37.2964 27.25 38.7515 25.7949 38.7515 24C38.7515 22.2051 37.2964 20.75 35.5015 20.75C33.7065 20.75 32.2515 22.2051 32.2515 24C32.2515 25.7949 33.7065 27.25 35.5015 27.25Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/more_options.2490abb5c329b9754ba2d53de3b07cff.svg";
export { ForwardRef as ReactComponent };